import React from 'react';
import { Tooltip } from 'react-tippy';
import { Link } from '../../Link';

const GoodDataDashboard = ({ user }) => {
  if (user?.isOrganisationAdmin && user?.show_gooddata_dashboard) {
    return (
      <div className="navbar-menu-item">
        <Link href="/analytics" classNameProp="navbar-menu-item-link" target="_self">
          <Tooltip arrow title="Analytics" position="bottom" animation="fade" theme="light">
            <span className="icon icon-analytics-white nav-icon" />
          </Tooltip>
          <span className="icon-text">Analytics</span>
        </Link>
      </div>
    );
  }

  return null;
};

export default GoodDataDashboard;
